/* global Word console */
import axiosBaseURL from "./httpCommon";

const customXmlID = "MarkConditionXmlPartId";

const QueryData = async (soqlquery: string, childrelation: boolean) => {
  try {    
    const res = await axiosBaseURL
      .get("/sfserver/query?q=" + soqlquery, {
        withCredentials: true,
      })
      .catch(() => {
        return [];
      });    
    if (res.data != null) {
      if (!childrelation) return res.data.records;
      else if (childrelation) return res.data;
    } else return null;
  } catch (err) {
    return [];
  }
};

export const readLockdetailsfromDoc = async () => {
  let returnId = {readonly: "",locked:""};
  await Word.run(async (context) => {
    const properties = context.document.properties.customProperties;
    properties.load("key,type,value");
    await context.sync();
    let isreadonly="";
    let slockedby="";        
    for (let i = 0; i < properties.items.length; i++) {
      console.log(properties.items[i].key);
      if (properties.items[i].key == "IsRead") {
        isreadonly = properties.items[i].value;
      }
      else if (properties.items[i].key == "LockedName") {
        slockedby = properties.items[i].value;
      }      
    }
    returnId={readonly: isreadonly, locked: slockedby}
  });
  return returnId;
};

export const GetLockdetails = async (doclockid: any) => {
  let IsRightAllow = {id:"NA",type: "",name: ""};
  let loginUsrid = localStorage.getItem("sfuserid");
  if (doclockid != null && loginUsrid != null && loginUsrid != undefined) {    
    //Check for Locked or not
    var doclock = await QueryData(
      "SELECT Id, Locked_By__c, Locked_By__r.Name, IsLocked__c FROM Template__c where Id = '" + doclockid + "'",
      false
    );
    if (doclock != null && Array.isArray(doclock) && doclock.length > 0) {
      if (doclock[0].IsLocked__c === true) {
        IsRightAllow = { name: doclock[0].Locked_By__r.Name, type: "template", id: doclock[0].Locked_By__c };
      }
    }
    //Ends here
    //Check for Template versions
    if (IsRightAllow.id === "NA") {      
      doclock = await QueryData(
        "SELECT Id, Locked_By__c, Locked_By__r.Name, IsLocked__c FROM Template_Version__c where Id = '" +
          doclockid +
          "'",
        false
      );
      if (doclock != null && Array.isArray(doclock) && doclock.length > 0) {
        if (doclock[0].IsLocked__c === true) {
          IsRightAllow = { name: doclock[0].Locked_By__r.Name, type: "template version", id: doclock[0].Locked_By__c  };
        }
      }
      //Ends here
    }
  }  
  return IsRightAllow;
};

export async function isCustomXMLexists() {
  return await Word.run(async (context) => {
    const settings = context.document.settings;
    const xmlPartIDSetting = settings.getItemOrNullObject(customXmlID).load("value");
    await context.sync();
    if (xmlPartIDSetting.value) {
      return true;
    } else {
      return false;
    }
  });
}

export const InsertAIGenText = async (text: any) => {
  await Word.run(async (context) => {
    const bodysel = context.document.getSelection();
    bodysel.insertText(text, "Start");
    await context.sync();
  });
}

export const readAgreemntID = async () => {
  let returnId = "";
  await Word.run(async (context) => {
    const properties = context.document.properties.customProperties;
    properties.load("key,type,value");
    await context.sync();
    for (let i = 0; i < properties.items.length; i++) {
      console.log(properties.items[i].key);
      if (properties.items[i].key == "Agreement ID") {
        returnId = properties.items[i].value;
      }
    }
  });
  return returnId;
};

export const readTemplateID = async () => {
  let returnId = "";
  await Word.run(async (context) => {
    const properties = context.document.properties.customProperties;
    properties.load("key,type,value");
    await context.sync();
    for (let i = 0; i < properties.items.length; i++) {
      console.log(properties.items[i].key);
      if (properties.items[i].key == "Template ID") {
        returnId = properties.items[i].value;
      }
    }
  });
  return returnId;
};

//Locked ID
export const readLockedID = async() => {
  let returnId = "";
  await Word.run(async (context) => {
    const properties = context.document.properties.customProperties;
    properties.load("key,type,value");
    await context.sync();
    for (let i = 0; i < properties.items.length; i++) {
      console.log(properties.items[i].key);
      if (properties.items[i].key == "Locked ID") {
        returnId = properties.items[i].value;
      }
    }
  });
  return returnId;
}

export const readLockVersionID = async() => {
  let returnId = "";
  await Word.run(async (context) => {
    const properties = context.document.properties.customProperties;
    properties.load("key,type,value");
    await context.sync();
    for (let i = 0; i < properties.items.length; i++) {
      console.log(properties.items[i].key);
      if (properties.items[i].key == "Template ID") {
        returnId = properties.items[i].value;
      }
    }
  });
  return returnId;
}

export const readTemplateVersionID = async () => {
  let returnId = "";
  await Word.run(async (context) => {
    const properties = context.document.properties.customProperties;
    properties.load("key,type,value");
    await context.sync();
    for (let i = 0; i < properties.items.length; i++) {
      console.log(properties.items[i].key);
      if (properties.items[i].key == "Template Ver") {
        returnId = properties.items[i].value;
      }
    }
  });
  return returnId;
};

export const DeleteTemplateverIDinDoc = async () => {
  await Word.run(async (context) => {
    try
    {
      var PropItem = context.document.properties.customProperties.getItem("Template Ver");
      if (PropItem != null) {
        PropItem.delete();
      }
      await context.sync();
    }
    catch{
      console.log("Error");
    }
  });
};

export const inserttemplateIDinDoc = async (id: any) => {
  await Word.run(async (context) => {
    context.document.properties.customProperties.add("Template ID", id);
    await context.sync();
  });
};

export const inserttemplateVersionIDinDoc = async (id: any) => {
  await Word.run(async (context) => {
    context.document.properties.customProperties.add("Template ID", id);
    await context.sync();
  });
};

export const addCustomXmlPart = async (sXMLpart: any) => {
  let IsCusXMLPartExists = await isCustomXMLexists();
  if (!IsCusXMLPartExists) {
    await Word.run(async (context) => {
      const originalXml = "<sffields></sffields>";
      const customXmlPart = context.document.customXmlParts.add(originalXml);
      customXmlPart.load("id");
      await context.sync();
      const settings = context.document.settings;
      settings.add(customXmlID, customXmlPart.id);
      await context.sync();
    });
  }
  await insertElement(sXMLpart);
};

export async function insertElement(strXML: any) {
  await Word.run(async (context) => {
    console.log("Insert XML");
    console.log(strXML);
    const settings = context.document.settings;
    const xmlPartIDSetting = settings.getItemOrNullObject(customXmlID).load("value");
    await context.sync();
    if (xmlPartIDSetting.value) {
      console.log("Adding...");
      const customXmlPart = context.document.customXmlParts.getItem(xmlPartIDSetting.value);
      customXmlPart.insertElement("/sffields", strXML, {});
      console.log("Added...");
      await context.sync();
      console.log("Saved...");
    } else {
      console.warn("Didn't find custom XML part to insert element into");
    }
  });
}

export async function GetLabelfromCC(id: any) {
  let labeltext = "";
  await Word.run(async (context) => {
    const settings = context.document.settings;
    const xmlPartIDSetting = settings.getItemOrNullObject(customXmlID).load("value");
    await context.sync();
    if (xmlPartIDSetting.value) {
      const customxmlpart = context.document.customXmlParts.getItem(xmlPartIDSetting.value);
      const xpathToQueryFor = "/sffields/field[@id='" + id + "']" + "/label";
      const connodes = customxmlpart.query(xpathToQueryFor, {});
      await context.sync();
      if (connodes.value.length > 0) {
        labeltext = connodes.value.toString();
        labeltext = labeltext.replace("<label>", "");
        labeltext = labeltext.replace("</label>", "");
      }
    }
  });
  console.log(labeltext);
  return labeltext;
}

export async function CheckCChasCondition(id: any) {
  let blnhascondition = false;
  console.log(id);
  await Word.run(async (context) => {
    const settings = context.document.settings;
    const xmlPartIDSetting = settings.getItemOrNullObject(customXmlID).load("value");
    await context.sync();
    if (xmlPartIDSetting.value) {
      const customxmlpart = context.document.customXmlParts.getItem(xmlPartIDSetting.value);
      const xpathToQueryFor = "/sffields/field[@id='" + id + "']" + "/conditions/condition";
      const connodes = customxmlpart.query(xpathToQueryFor, {});
      await context.sync();
      console.log(connodes.value.length);
      if (connodes.value.length > 0) {
        blnhascondition = true;
      }
      if (!blnhascondition) {
        const xpathToQueryFor = "/sffields/field[@id='" + id + "']" + "/rowcondition";
        const connodes = customxmlpart.query(xpathToQueryFor, {});
        await context.sync();
        console.log(connodes.value.length);
        if (connodes.value.length > 0) {
          blnhascondition = true;
        }
      }
    }
  });
  return blnhascondition;
}

// async function GetInsertCCContentCtrl(objcell: any, objselnode: any) {
//   await Word.run(async (context) => {
//     console.log("Entering into Word function");
//     var objcc = objcell.insertContentControl(Word.ContentControlType.richText);
//     console.log("Added CC");
//     objcc.title = "Fields";
//     objcc.placeholderText = objselnode.label;
//     objcc.tag = objselnode.id;
//     objcc.load("id");
//     await context.sync();
//   });
// }

export async function Inserttablecells(values: any, strnodeid: string, strnodelabel: string) {
  await Word.run(async (context) => {
    if (strnodelabel.length === 0) {
      strnodelabel = strnodeid;
    }
    var selectionRange = context.document.getSelection();
    var paragraph = selectionRange.insertParagraph("", "Before");
    await context.sync();
    let headvals = [];
    for (var i = 0; i < 2; i++) {
      headvals.push([]);
      headvals[i].push(new Array(values.length));
      for (var j = 0; j < values.length; j++) {
        headvals[0][j] = values[j].label;
      }
    }
    var table = paragraph.insertTable(2, values.length, "Before", headvals);
    await context.sync();
    const cellscc = [];
    for (var k = 0; k < values.length; k++) {
      var objselnode = values[k];
      var cell = table.getCell(1, k).body;
      var objcc = cell.insertContentControl(Word.ContentControlType.richText);
      objcc.title = "Fields";
      objcc.placeholderText = objselnode.label;
      objcc.tag = objselnode.id;
      objcc.load("id");
      cellscc.push(objcc);
    }
    await context.sync();
    for (k = 0; k < values.length; k++) {
      objselnode = values[k];
      console.log("While inserting cells");
      console.log(objselnode);
      cell = table.getCell(1, k).body;
      objcc = cell.contentControls.getFirstOrNullObject();
      var strnewrel = "";
      if (objselnode.relationshipname != null) {
        strnewrel = objselnode.relationshipname;
        strnewrel = strnewrel.replace(",null", "," + objselnode.name);
        strnewrel = strnewrel.split(",").join(".");
      }
      var newnodexml =
        "<field id='" +
        cellscc[k].id +
        "'>" +
        "<name>" +
        objselnode.name +
        "</name>" +
        "<label>" +
        objselnode.label +
        "</label>" +
        "<conditions />" +
        "<reference>" +
        strnewrel +
        "</reference>" +
        "<type>" +
        objselnode.type +
        "</type>" +
        "<sfvalue/>" +
        "<tablemode>y</tablemode>" +
        "</field>";
      await addCustomXmlPart(newnodexml);
    }
    var tablerng = table.getRange();
    objcc = tablerng.insertContentControl(Word.ContentControlType.richText);
    objcc.title = "Repeat";
    objcc.load("id");
    await context.sync();
    console.log("table node id: " + objcc.id);
    var tablenodexml =
      "<field id='" +
      objcc.id +
      "'>" +
      "<name>" +
      "TableRepeat" +
      "</name>" +
      "<label>" +
      strnodelabel +
      "</label>" +
      "<conditions />" +
      "<reference>" +
      strnodeid +
      "</reference>" +
      "<type>Table</type>" +
      "<sfvalue/>" +
      "<tablemode>y</tablemode>" +
      "</field>";
    await addCustomXmlPart(tablenodexml);
  });
}

export async function DeleteCCbyId(id: any) {
  await Word.run(async (context) => {
    let cctrl = context.document.contentControls.getByIdOrNullObject(id);
    context.load(cctrl);
    await context.sync();
    if (!cctrl.isNullObject) {
      cctrl.delete(false);
      await context.sync();
    }
  });
}

export async function DeleteClausesbyId(id: any) {
  await Word.run(async (context) => {
    let cctrl = context.document.contentControls.getByIdOrNullObject(id);
    context.load(cctrl);
    if(cctrl!=null){
      cctrl.delete(true);
  }
  });
}

export async function SelectCCbyId(id: any) {
  await Word.run(async (context) => {
    let cctrl = context.document.contentControls.getById(id);
    cctrl.getRange().select();
  });
}

export async function GetDetailsofCC(id: any, rowcondition = false) {
  let strType = "";
  let strName = "";
  let strAll = "";
  let tablemode = false;
  let strLabel = "";
  let strdateformat = "";
  let strnumformat = "";
  let strsymbol = "";
  let strdisplayat= "";
  //Table properties
  let strsmartfield = "";
  let strRowCondition = "";
  //Ends here
  await Word.run(async (context) => {
    const settings = context.document.settings;
    const xmlPartIDSetting = settings.getItemOrNullObject(customXmlID).load("value");
    await context.sync();
    if (xmlPartIDSetting.value) {
      const customxmlpart = context.document.customXmlParts.getItem(xmlPartIDSetting.value);
      let xpathToQueryFor = "/sffields/field[@id='" + id + "']" + "/name";
      let connodes = customxmlpart.query(xpathToQueryFor, {});
      await context.sync();
      if (connodes.value.length > 0) {
        strName = connodes.value[0];
      }
      xpathToQueryFor = "/sffields/field[@id='" + id + "']" + "/type";
      connodes = customxmlpart.query(xpathToQueryFor, {});
      await context.sync();
      if (connodes.value.length > 0) {
        strType = connodes.value[0];
      }
      xpathToQueryFor = "/sffields/field[@id='" + id + "']" + "/conditions/all";
      connodes = customxmlpart.query(xpathToQueryFor, {});
      await context.sync();
      if (connodes.value.length > 0) {
        strAll = connodes.value[0];
      }
      xpathToQueryFor = "/sffields/field[@id='" + id + "']" + "/reference";
      connodes = customxmlpart.query(xpathToQueryFor, {});
      await context.sync();
      if (connodes.value.length > 0) {
        if (RemoveHTMLtags(connodes.value[0]).length > 0) {
          strName = connodes.value[0];
        }
      }
      xpathToQueryFor = "/sffields/field[@id='" + id + "']" + "/tablemode";
      connodes = customxmlpart.query(xpathToQueryFor, {});
      await context.sync();
      if (connodes.value.length > 0) {
        if (RemoveHTMLtags(connodes.value[0]).length > 0) {
          tablemode = true;
        }
      }

      xpathToQueryFor = "/sffields/field[@id='" + id + "']" + "/label";
      connodes = customxmlpart.query(xpathToQueryFor, {});
      await context.sync();
      if (connodes.value.length > 0) {
        if (RemoveHTMLtags(connodes.value[0]).length > 0) {
          strLabel = connodes.value[0];
        }
      }

      if (rowcondition) {
        xpathToQueryFor = "/sffields/field[@id='" + id + "']" + "/rowcondition";
        connodes = customxmlpart.query(xpathToQueryFor, {});
        await context.sync();
        if (connodes.value.length > 0) {
          strAll = connodes.value[0];
        }
      }

      xpathToQueryFor = "/sffields/field[@id='" + id + "']" + "/rowcondition";
      connodes = customxmlpart.query(xpathToQueryFor, {});
      await context.sync();
      if (connodes.value.length > 0) {
        strRowCondition = connodes.value[0];
      }

      //smartfield
      xpathToQueryFor = "/sffields/field[@id='" + id + "']" + "/smartfield";
      connodes = customxmlpart.query(xpathToQueryFor, {});
      await context.sync();
      if (connodes.value.length > 0) {
        strsmartfield = connodes.value[0];
      }

      //Date format
      xpathToQueryFor = "/sffields/field[@id='" + id + "']" + "/dateformat";
      connodes = customxmlpart.query(xpathToQueryFor, {});
      await context.sync();
      if (connodes.value.length > 0) {
        strdateformat = connodes.value[0];
      }

      //Number format
      xpathToQueryFor = "/sffields/field[@id='" + id + "']" + "/numberformat";
      connodes = customxmlpart.query(xpathToQueryFor, {});
      await context.sync();
      if (connodes.value.length > 0) {
        strnumformat = connodes.value[0];
      }

      //Symbol
      xpathToQueryFor = "/sffields/field[@id='" + id + "']" + "/symbolval";
      connodes = customxmlpart.query(xpathToQueryFor, {});
      await context.sync();
      if (connodes.value.length > 0) {
        strsymbol = connodes.value[0];
      }      

      //Symbol display
      xpathToQueryFor = "/sffields/field[@id='" + id + "']" + "/displaypos";
      connodes = customxmlpart.query(xpathToQueryFor, {});
      await context.sync();
      if (connodes.value.length > 0) {
        strdisplayat = connodes.value[0];
      }

    }
  });
  return {
    type: RemoveHTMLtags(strType),
    name: RemoveHTMLtags(strName),
    all: RemoveHTMLtags(strAll),
    label: RemoveHTMLtags(strLabel),
    istable: tablemode,
    smartfield: RemoveHTMLtags(strsmartfield),
    dateformat: RemoveHTMLtags(strdateformat),
    tablerowcondition: RemoveHTMLtags(strRowCondition),
    numberformat: RemoveHTMLtags(strnumformat),
    symbolstring: RemoveHTMLtags(strsymbol),
    displaysymbol: RemoveHTMLtags(strdisplayat),
  };
}

function RemoveHTMLtags(strValue: string) {
  let orgstr = strValue;
  orgstr = orgstr.replace("<symbol>", "<symbol> ");
  orgstr = orgstr.replace("</symbol>", " </symbol> ");
  orgstr = orgstr.replace(/(<([^>]+)>)/gi, "");
  return orgstr;
}

export async function DeleteCCProperties(
  id: any,
  isrow = false
) {
  await Word.run(async (context) => {
    try {
      const settings = context.document.settings;
      const xmlPartIDSetting = settings.getItemOrNullObject(customXmlID).load("value");
      await context.sync();      
      if (xmlPartIDSetting.value) {
        const customxmlpart = context.document.customXmlParts.getItem(xmlPartIDSetting.value);        
        let strcdtype = "conditions";
        if (isrow) {
          strcdtype = "rowcondition";
        }
        var xpathToQueryFor = "//field[@id='" + id + "']" + "/" + strcdtype;
        var conditionnodes = customxmlpart.query(xpathToQueryFor, {});
        await context.sync();
        if (conditionnodes.value.length > 0) {
          customxmlpart.deleteElement(xpathToQueryFor, {});
          await context.sync();
        }
      }
      var details = await GetDetailsofCC(id);
      if(details.type === "Clauses") {
        await DeleteClausesbyId(id);
      }
    } catch (error) {
      console.log(error);
    }
  });
}

export async function UpdateCCProperties(
  objlist: any,
  id: any,
  alltext: any,
  dateformat: any,
  isrow = false,
  smartprops: any,
  formatnumber: any,
  symvalue: any,
  displayposition: any
) {
  await Word.run(async (context) => {
    try {
      const settings = context.document.settings;
      const xmlPartIDSetting = settings.getItemOrNullObject(customXmlID).load("value");
      await context.sync();
      let seldateformat = dateformat + "";
      if (xmlPartIDSetting.value) {
        const customxmlpart = context.document.customXmlParts.getItem(xmlPartIDSetting.value);
        if (alltext.length > 0) {
          let strcdtype = "conditions";
          if (isrow) {
            strcdtype = "rowcondition";
          }
          var xpathToQueryFor = "//field[@id='" + id + "']" + "/" + strcdtype;
          var conditionnodes = customxmlpart.query(xpathToQueryFor, {});
          await context.sync();
          if (conditionnodes.value.length > 0) {
            customxmlpart.deleteElement(xpathToQueryFor, {});
            await context.sync();
          }
        }
        if (seldateformat != null && seldateformat.length > 0) {
          //Date formats delete
          xpathToQueryFor = "//field[@id='" + id + "']" + "/dateformat";
          conditionnodes = customxmlpart.query(xpathToQueryFor, {});
          await context.sync();
          if (conditionnodes.value.length > 0) {
            customxmlpart.deleteElement(xpathToQueryFor, {});
            await context.sync();
          }
          //Ends here
        }
        //Number format here
        console.log("formatnumber");
        console.log(formatnumber);
        if(formatnumber!=null && formatnumber.length > 0){
          xpathToQueryFor = "//field[@id='" + id + "']" + "/numberformat";
          conditionnodes = customxmlpart.query(xpathToQueryFor, {});
          await context.sync();
          if (conditionnodes.value.length > 0) {
            customxmlpart.deleteElement(xpathToQueryFor, {});
            await context.sync();
          }
        }
        //Ends here
        //Symbol value here
        if(symvalue!=null && symvalue.length > 0){
          xpathToQueryFor = "//field[@id='" + id + "']" + "/symbolval";
          conditionnodes = customxmlpart.query(xpathToQueryFor, {});
          await context.sync();
          if (conditionnodes.value.length > 0) {
            customxmlpart.deleteElement(xpathToQueryFor, {});
            await context.sync();
          }
        }
        //Ends here
        //Display pos here
        if(displayposition!=null && displayposition.length > 0){
          xpathToQueryFor = "//field[@id='" + id + "']" + "/displaypos";
          conditionnodes = customxmlpart.query(xpathToQueryFor, {});
          await context.sync();
          if (conditionnodes.value.length > 0) {
            customxmlpart.deleteElement(xpathToQueryFor, {});
            await context.sync();
          }
        }
        //Ends here
        //Properties Here
        if (smartprops.length > 0) {
          xpathToQueryFor = "//field[@id='" + id + "']" + "/smartfield";
          conditionnodes = customxmlpart.query(xpathToQueryFor, {});
          await context.sync();
          if (conditionnodes.value.length > 0) {
            customxmlpart.deleteElement(xpathToQueryFor, {});
            await context.sync();
          }
        }
        //Ends here
        let allcondtext = "";
        if (objlist != null && alltext.length > 0) {
          for (let i = 0; i < objlist.length; i++) {
            let markconditionstr =
              "<condition>" +
              "<type>" +
              "" +
              "</type>" +
              "<field>" +
              objlist[i].fieldname +
              "</field>" +
              "<symbol>" +
              objlist[i].operatorval +
              "</symbol>" +
              "<result>" +
              objlist[i].resultval +
              "</result>" +
              "</condition>";
            let wholestr = objlist[i].fieldname + " " + objlist[i].operatorval + " " + objlist[i].resultval;
            allcondtext = allcondtext + markconditionstr;
            if (wholestr.trim().length > 0) {
              var regex = new RegExp("\\b" + (i + 1).toString() + "\\b", "g");
              alltext = alltext.replace(regex, "(" + wholestr + ")");
            }
          }
          let writetext = "";
          if (alltext != "") {
            if (!isrow) {
              writetext = "<conditions>" + allcondtext + "<all>" + alltext + "</all>" + "</conditions>";
            } else {
              writetext = "<rowcondition>" + alltext + "</rowcondition>";
            }
          } else {
            writetext = "<conditions/>";
          }
          customxmlpart.insertElement("//field[@id='" + id + "']", writetext, {});
        }

        if (seldateformat != null && seldateformat.length > 0) {
          if(seldateformat === "None"){seldateformat="";}
          customxmlpart.insertElement(
            "//field[@id='" + id + "']",
            "<dateformat>" + seldateformat + "</dateformat>",
            {}
          );
        }

        if (formatnumber != null && formatnumber.length > 0) {
          if(formatnumber === "None"){formatnumber="";}
          customxmlpart.insertElement(
            "//field[@id='" + id + "']",
            "<numberformat>" + formatnumber + "</numberformat>",
            {}
          );
        }

        if (symvalue != null && symvalue.length > 0) {
          if(symvalue === "None"){symvalue="";}
          customxmlpart.insertElement(
            "//field[@id='" + id + "']",
            "<symbolval>" + symvalue + "</symbolval>",
            {}
          );
        }

        if (displayposition != null && displayposition.length > 0) {
          if(displayposition === "None"){displayposition="";}
          customxmlpart.insertElement(
            "//field[@id='" + id + "']",
            "<displaypos>" + displayposition + "</displaypos>",
            {}
          );
        }

        if (smartprops.length > 0) {
          customxmlpart.insertElement("//field[@id='" + id + "']", smartprops, {});
        }
      }
    } catch (error) {
      console.log(error);
    }
  });
}

export async function markConditioninCC(objlist: any, id: any, alltext: any, dateformat: any, isrow = false) {
  await Word.run(async (context) => {
    try {
      const settings = context.document.settings;
      const xmlPartIDSetting = settings.getItemOrNullObject(customXmlID).load("value");
      await context.sync();
      let seldateformat = dateformat + "";
      if (xmlPartIDSetting.value) {
        const customxmlpart = context.document.customXmlParts.getItem(xmlPartIDSetting.value);
        let strcdtype = "conditions";
        if (isrow) {
          strcdtype = "rowcondition";
        }
        var xpathToQueryFor = "//field[@id='" + id + "']" + "/" + strcdtype;
        var conditionnodes = customxmlpart.query(xpathToQueryFor, {});
        await context.sync();
        if (conditionnodes.value.length > 0) {
          customxmlpart.deleteElement(xpathToQueryFor, {});
          await context.sync();
        }
        //Date formats delete
        if (seldateformat.length > 0) {
          xpathToQueryFor = "//field[@id='" + id + "']" + "/dateformat";
          conditionnodes = customxmlpart.query(xpathToQueryFor, {});
          await context.sync();
          if (conditionnodes.value.length > 0) {
            customxmlpart.deleteElement(xpathToQueryFor, {});
            await context.sync();
          }
        }
        //Ends here

        //Row Condition here
        if (isrow) {
          xpathToQueryFor = "//field[@id='" + id + "']" + "/rowcondition";
          conditionnodes = customxmlpart.query(xpathToQueryFor, {});
          await context.sync();
          if (conditionnodes.value.length > 0) {
            customxmlpart.deleteElement(xpathToQueryFor, {});
            await context.sync();
          }
        }
        //Ends here

        let allcondtext = "";
        if (objlist != null) {
          for (let i = 0; i < objlist.length; i++) {
            let markconditionstr =
              "<condition>" +
              "<type>" +
              "" +
              "</type>" +
              "<field>" +
              objlist[i].fieldname +
              "</field>" +
              "<symbol>" +
              objlist[i].operatorval +
              "</symbol>" +
              "<result>" +
              objlist[i].resultval +
              "</result>" +
              "</condition>";
            let wholestr = objlist[i].fieldname + " " + objlist[i].operatorval + " " + objlist[i].resultval;
            allcondtext = allcondtext + markconditionstr;
            if (wholestr.trim().length > 0) {
              var regex = new RegExp("\\b" + (i + 1).toString() + "\\b", "g");
              alltext = alltext.replace(regex, "(" + wholestr + ")");
            }
          }
          let writetext = "";
          if (alltext != "") {
            if (!isrow) {
              writetext = "<conditions>" + allcondtext + "<all>" + alltext + "</all>" + "</conditions>";
            } else {
              writetext = "<rowcondition>" + alltext + "</rowcondition>";
            }
          } else {
            writetext = "<conditions/>";
          }
          //Check for writetext
          var regex1 = new RegExp("<=", "g");
          writetext = writetext.replace(regex1,"&lt;=");
          //Ends here
          customxmlpart.insertElement("//field[@id='" + id + "']", writetext, {});
          if (seldateformat.length > 0) {
            customxmlpart.insertElement(
              "//field[@id='" + id + "']",
              "<dateformat>" + seldateformat + "</dateformat>",
              {}
            );
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  });
}
